import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FollowButtonComponent } from './follow-button.component';

import { SvgModule } from '@app/shared/components/svg/svg.module';

@NgModule({
  imports: [CommonModule, SvgModule],
  exports: [FollowButtonComponent],
  declarations: [FollowButtonComponent]
})
export class FollowButtonModule {}
